import request from "../request";

/**
 * 焱火数据库 的字典 根据类型查询字典列表
 */
export function selectDictByType(type) {
    return request({
        url: 'sys/dict/selectDictByType',
        method: 'get',
        params: {type}
    })
}

/**
 *  OA数据库 的字典 根据类型查询字典列表
 */
export function selectOaDictByType(item) {
    return request({
        url: 'sys/OaDict/getOaDict',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item
    })
}

/**
 *  查询焱火数据库中字典-根据key
 */
export function getDictByKey(item) {
    return request({
        url: 'sys/OaDict/getDictByKey',
        method: 'POST',
        dataType: "json",
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        },
        data: item
    })
}